module.exports = __webpack_public_path__ + "exo-latin-300italic.a2ca6baedb32297ce871.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-300italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-300italic.svg
// module chunks = styles